import { render } from "./App.vue?vue&type=template&id=3b2c4f65"
const script = {}

import "./assets/style.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/Users/kamoliddin/Documents/iWork/Valvoline/promo2025/promo2025.lubricoil.uz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__